<template>
  <div class="img-item-box">
    <img :src="imgSrc" />
  </div>
</template>

<script>
import { i18n } from "utils/util";

export default {
  props: {
    data: String,
  },
  inject: ["isUseI18n"],
  computed: {
    imgSrc() {
      return this.isUseI18n ? i18n(this.data) : this.data;
    },
  },
};
</script>

<style lang="scss">
.img-item-box {
  height: 100%;
  width: 100%;
  position: relative;
  img {
    display: block;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

body.ie11 {
  .img-item-box img {
    width: auto;
    min-width: 100%;
  }
}
</style>
